import PropTypes from "prop-types";
import { SimpleBlockContent } from "../../SimpleBlockContent";
import styles from "./styles/description.module.css";

export function Description({ description = null }) {
  if (!description) {
    return null;
  }

  return (
    <article className={styles.section}>
      <div className={styles.container}>
        <SimpleBlockContent blocks={description} />
      </div>
    </article>
  );
}

Description.propTypes = { description: PropTypes.array };
